import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Table from "../../../Table";
import ContantLoader from "views/ContantLoader";
import { useSelector, useDispatch } from "react-redux";
import "./tabs.css"
import { exportNotes } from 'api/ExportApi'

import CreateNoteModal from '../CreateNoteModal'
import { putNoteByIdApi, getNoteByIdApi, getNotesApi, getNotesCountApi, createNoteApi } from "api/AccountsApi"
export default function NotesTab({ personData }) {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(-1);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [onEdit, setOnEdit] = useState(null)
  const [onEditText, setOnEditText] = useState("")
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { eventandsignalLoading } = useSelector(
    (state) => state.eventandsignalSetter
  );
  const searchText = useRef("");

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    setLoading(true);
    // dispatch(setEventSignalLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);


    await getNotesCountApi(personData.id)
      .then((data) => {
        setPageCount(Math.ceil(data.count / pageSize));
        setTotal(data.count);
      })
      .catch((e) => { });
    await getNotesApi(personData.id, pageSize, startRow)
      .then((data) => {
        setDataApi(data);
        setLoading(false);
      })

  }, []);

  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => [

      {
        Header: "Text",
        accessor: "text",
      },
      {
        Header: "Owner",
        accessor: "createdBy.name",
      },
      {
        Header: "Created Time",
        accessor: "createdAt",
      },
      {
        // width: 300,
        Header: "",
        accessor: "_",
        Cell: ({ cell }) => (
          (
            <div className="">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Edit Note
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-edit"
                  data-toggle='modal'
                  data-target={
                    `#createNote`
                  }
                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={() => { setOnEdit(cell.row.original.id); setOnEditText(cell.row.original.text) }}

                ></i>
              </OverlayTrigger>

            </div>
          )
        ),
      },
      {
        // width: 300,
        Header: "",
        accessor: "_2",
        Cell: ({ cell }) => (
          (
            <div className="">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Delete Note
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-trash"

                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={() => {
                    putNoteByIdApi(cell.row.original.id, { isDeleted: true }).then((d) => {
                      let all = [...dataApi]
                      let t = all.filter(r => r.id != cell.row.original.id)
                      setDataApi(t)
                    })
                  }}

                ></i>
              </OverlayTrigger>

            </div>
          )
        ),
      },



    ],
    [dataApi]
  );
  const handleSave = (text) => {
    if (onEdit) {
      let id = onEdit
      putNoteByIdApi(id, { text: text }).then((d) => {
        let all = [...dataApi]
        let t = all.filter(r => r.id == id)
        t = t[0]
        t.text = text
        setDataApi(all)

      })
      return
    }
    createNoteApi(personData.id, text).then((d) => {
      getNoteByIdApi(d.id).then((note) => {
        let all = [...dataApi]
        all.push(note)
        setDataApi(all)
      })

    })
  }
  const CreateNotesButton = () => {
    return <a
      className="tpr lg_btn primary mr-2"
      data-toggle='modal'
      data-target={
        `#createNote`
      }
      onClick={(e) => setOnEdit(null)}
      style={{ cursor: 'pointer', fontSize: '18px', lineHeight: '22px' }}
    >
      <span>
        <i className="fas fa-plus mr-2"></i>
      </span>
      Create Note
    </a>
  }
  return (
    <div id='notes'>
      <div className="">
        <CreateNotesButton />
      </div>

          {/* <input
              onClick={exportNotes}
              type="submit"
              name="Save"
        style={{
          cursor: 'pointer', fontSize: '18px', lineHeight: '22px',     right: '140px',
          height: '33px'
}}
              className='tpr lg_btn primary btn'
  
              value="export"
                /> */}

      <div className='mt-5'></div>
      {dataApi ? (
        <div className="dataTableOuter">

          {total == 0 ?
            <div
              style={{
                textAlign: 'center',
                fontWeight: 900,
                fontSize: '19px',
                fontFamily: 'DM Sans'
              }}

            >No Notes to show.</div>
            :
            <Table
              columns={columns}
              data={data}
              pageCount={pageCount}
              fetchData={fetchData}
              loading={loading}
            ></Table>
          }


        </div>
      ) : (
        <ContactLoader />
      )}
      <CreateNoteModal handleSave={handleSave} text={onEditText} />
    </div>
  );
}
